module.exports = __webpack_public_path__ + "img/blog-3-1.beaef8f8.webp";